<template>
    <div class="product-page">
        <div class="product-page__container md:container">
            <div class="product-page__left">
                <template v-for="item in blok.left_column" :key="item._uid">
                    <component :is="item.component" :blok="item" />
                </template>
            </div>
            <div v-if="blok.right_column" class="product-page__right">
                <L4QuoteForm :blok="blok.right_column[0]" :simple="true" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IL4TwoColumn } from '~/../types/components/L4TwoColumn';

defineProps<{ blok: IL4TwoColumn }>();
</script>

<style lang="postcss" scoped>
.product-page {
    @apply bg-white;
    &__container {
        @apply flex flex-col md:flex-row;
    }
    &__left {
        @apply p-4 pr-7 flex-grow order-2 md:order-1;
    }
    &__right {
        @apply bg-l4-accent md:max-w-[370px] shrink-0 flex-grow order-1 md:order-2;
    }
}
</style>
